import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide QueryClient, exported as a module singleton rather than created
 * per-render in the provider (e.g. `useState(() => new QueryClient())`). Two reasons:
 *
 *  1. The provider is mounted in more than one place (`app/layout.tsx` and
 *     `settings/CalendarSelectionModal.tsx`). A per-provider client would give those
 *     trees separate caches, and `logout()`'s teardown would only clear one of them.
 *  2. Non-React code needs the same instance — `logout()` in `useUserStore` calls
 *     `queryClient.clear()` to flush cached lead detail and other payloads that can
 *     hold PHI/PII, so they don't survive a user switch.
 *
 * Safe because the app is a static export (`output: 'export'` — no server runtime).
 * If we ever adopt SSR, a module singleton would be shared across concurrent server
 * requests and leak data between users; switch to the per-request `useState` pattern
 * then, and give `logout()` another teardown seam.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      retry: 1,
    },
  },
});
